import { createContext, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';

const ProjectWarningContext = createContext();

const initialState = {
  showRiskBar: false,
  projectWarnings: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'GET_PROJECT_WARNINGS': {
      return {
        ...state,
        projectWarnings: action.payload.projectWarnings,
      };
    }
    case 'SHOW_RISK_BAR': {
      return { ...state, showRiskBar: action.payload.showRiskBar };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export const ProjectWarningProvider = ({ children }) => {
  const [{ showRiskBar, projectWarnings }, dispatch] = useReducer(reducer, initialState);
  const values = useMemo(() => ({
    showRiskBar,
    projectWarnings,
    dispatch,
  }));
  return <ProjectWarningContext.Provider value={values}>{children}</ProjectWarningContext.Provider>;
};

ProjectWarningProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ProjectWarningContext;
